import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FhImageComponent } from './components/fh-image/fh-image.component';
import { ImageModule } from 'primeng/image';

@NgModule({
  imports: [CommonModule, ImageModule],
  declarations: [FhImageComponent],
  exports: [FhImageComponent]
})
export class FhImageModule {}
